import React from 'react';
import CardCommon, { CardCommonType } from '@op/components/CardCommon';
import { percentageFormat, reviewsFormat } from '@op/utils/value';
import classnames from 'classnames';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import './index.scss';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { isEmpty } from '@gp/utils/common';

type IAnalysisCard = {
  className?: string;
  title?: string | JSX.Element;
  value: number;
  percentValue?: number;
  formatValue?: (value: number, ...restProps: any) => string | number;
  formatPercentValue?: (value: number, ...restProps: any) => string | number;
  footer?: React.ReactNode;
  loading?: boolean;
  empty?: boolean;
  height?: number;
  bubbleProps?: any;
  contentCard?: boolean;
  hasEmptyImg?: boolean;
  hasEmptyTitle?: boolean;
  hasEmptyDesc?: boolean;
  emptyDescText?: string;
  nearValue?: string;
} & CardCommonType;
export default function AnalysisCard({
  title,
  value,
  percentValue,
  formatValue = reviewsFormat,
  formatPercentValue = percentageFormat,
  className,
  footer,
  bubbleProps,
  nearValue,
  ...restProps
}: IAnalysisCard) {
  return (
    <CardCommon
      title={title}
      className={classnames(className, 'dbo-analysis-card')}
      loadingHeight={restProps?.height || 60}
      emptyHeight={restProps?.height || 60}
      hasEmptyImg={false}
      {...restProps}
    >
      <div className="dbo-analysis-card-value">
        <span className="value-text">
          {formatValue(value)}
          {nearValue && <span className="near-value-text">{nearValue}</span>}
        </span>
        {!isEmpty(percentValue) && (
          <RingRatioBubble {...bubbleProps}>
            <PercentageItem
              percentage={percentValue as number}
              formateFunc={formatPercentValue}
            ></PercentageItem>
          </RingRatioBubble>
        )}
      </div>
      <div className="dbo-analysis-card-footer">{footer}</div>
    </CardCommon>
  );
}
